import { Tooltip, styled } from '@mui/material';

const BadgeContainer = styled('div')`
  display: flex;
  justify-content: left;
  width: 60px;
`;

const BadgeIconDiv = styled('div')`
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  top: 0.875rem;
  left: -21px;
  background-color: white;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 #d1d1d1;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const BadgeImg = styled('img')`
  position: relative;
  display: block;
  padding: 6px;
`;

interface Props {
  badgeSrc?: string;
  svgSrc: string;
  tooltipText?: string;
}

// Source is combination an svg icon, plus an optional badge source
const IconWithBadge = (props: Props) => {
  const { badgeSrc, svgSrc, tooltipText } = props;
  return (
    <BadgeContainer>
      <BadgeImg src={svgSrc} />
      {badgeSrc && (
        <BadgeIconDiv>
          {tooltipText ? (
            <Tooltip placement="top" title={tooltipText}>
              <BadgeImg alt="badge" height="12" src={badgeSrc} width="12" />
            </Tooltip>
          ) : (
            <BadgeImg alt="badge" height="12" src={badgeSrc} width="12" />
          )}
        </BadgeIconDiv>
      )}
    </BadgeContainer>
  );
};

export default IconWithBadge;
